export async function useTalkjsInitializer() {
  const { data: currentUser } = useAuth()
  const router = useRouter()
  const talkjsAppId = String(useRuntimeConfig().public.TALKJS_APP_ID)

  const chatStore = useChatStore()
  const { getSignature, startSession, updateUnreadMessageCount } = chatStore
  await getSignature()
  await startSession(currentUser.value, talkjsAppId)
  const session = chatStore.session!

  session.onDesktopNotificationClicked(() => {
    router.push('/chat')
  })

  session.unreads.onChange(function (unreadConversations) {
    const amountOfUnreads = unreadConversations.length
    updateUnreadMessageCount(amountOfUnreads)

    if (amountOfUnreads > 0) {
      document.title = '(' + amountOfUnreads + ') CanXChange'
    }
    else {
      document.title = 'CanXChange'
    }
  })
}
